import { render } from "./OrganizationSettingsTicketSettingsPanel.vue?vue&type=template&id=62e9aa53"
import script from "./OrganizationSettingsTicketSettingsPanel.vue?vue&type=script&lang=js"
export * from "./OrganizationSettingsTicketSettingsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__